import { ModelResource } from './resource';
import { type PresignedUrl, Remittance, Attachment } from '../models';
import type { AxiosResponse } from 'axios';

export class Remittances extends ModelResource<Remittance> {
  model = Remittance;

  resourcePath = 'v1/remittances';

  async process(remittance: Remittance): Promise<Remittance> {
    return this.api.post(this.path(remittance.id, 'process'), {}).then((res) => {
      remittance.updateFromJson(res.data);
      return remittance;
    });
  }

  async upload(
    entityId: undefined,
    filename: string,
    mime_type: string,
    presignUrlParams: Record<string, any>,
  ): Promise<{
    presignedUrl: PresignedUrl;
    remittance: Remittance;
    attachment: Attachment | null;
  }> {
    const response = await this.api.post(this.path('upload'), {
      data: {
        filename,
        mime_type,
        ...presignUrlParams,
      },
    });

    const { remittance, presigned_url } = response.data;
    const remittanceRecord = Remittance.fromJson(remittance);

    return {
      remittance: remittanceRecord,
      presignedUrl: presigned_url,
      attachment: remittanceRecord?.attachment,
    };
  }
}
